export * as NotesApi from './api';

export enum NoteRelation {
  Adviser = 'adviser',
  Investor = 'investor',
  Investment = 'investment',
}
